import React from "react";

export function Mascot({ title, text, size = 150, testid = "mascot-empty", src = "/mascot-sad.webp", children }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center text-center py-8 px-4">
      <img src={src} alt="" draggable={false} className="gs-sad mix-blend-multiply" style={{ width: size, height: "auto" }} />
      <div className="gs-walk-shadow" style={{ width: size * 0.65 }} />
      {title && <p className="mt-5 text-base font-extrabold text-slate-900">{title}</p>}
      {text && <p className="text-sm text-slate-500 mt-1 max-w-xs">{text}</p>}
      {children}
    </div>
  );
}
